/* =====================================================================
   Au Delà des Fleurs — pages boutique « Le Sourire » (collections + fiches produit)
   · « Livrable aujourd'hui » seulement si c'est vrai (heure de Paris, heures limites du thème)
   · Fiche produit : tailles, prix, croquis, livraison offerte, galerie, zoom, barre d'achat mobile
   · Collection : tri, texte d'intro repliable
   · « Vous aimerez aussi » chargé en différé
   ===================================================================== */
(function () {
  'use strict';

  var DAYS = ['', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi', 'dimanche'];

  function parisNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', hour12: false }).formatToParts(new Date());
    var get = function (t) { return (parts.find(function (p) { return p.type === t; }) || {}).value; };
    return { day: { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 }[get('weekday')], hour: parseInt(get('hour'), 10) % 24 };
  }

  /* ---------- Livraison du jour ---------- */
  function ship(scope) {
    (scope || document).querySelectorAll('[data-adf-cutoffs]').forEach(function (root) {
      try {
        var c = root.getAttribute('data-adf-cutoffs').split(',').map(function (n) { return parseInt(n, 10) || 0; });
        var cut = { 1: c[0], 2: c[1], 3: c[2], 4: c[3], 5: c[4], 6: c[5], 7: c[6] };
        var now = parisNow();
        var today = cut[now.day] > 0 && now.hour < cut[now.day];
        var label = null;
        if (!today) {
          for (var d = 1; d <= 7 && !label; d++) {
            var nd = ((now.day - 1 + d) % 7) + 1;
            if (cut[nd] > 0) label = d === 1 ? 'demain' : DAYS[nd];
          }
        }
        root.querySelectorAll('[data-adf-cut-h]').forEach(function (el) { if (cut[now.day] > 0) el.textContent = cut[now.day] + 'h'; });
        root.querySelectorAll('[data-adf-when]').forEach(function (el) {
          el.hidden = (el.getAttribute('data-adf-when') === 'today') !== today;
        });
        if (today || !label) return;
        root.querySelectorAll('[data-adf-later]').forEach(function (el) {
          if (!el.dataset.adfTpl) el.dataset.adfTpl = el.textContent;
          el.textContent = el.dataset.adfTpl.replace('[jour]', label);
        });
        var later = root.getAttribute('data-adf-later');
        if (later) {
          root.querySelectorAll('[data-adf-ship-label]').forEach(function (s) { s.textContent = later.replace('[jour]', label); });
          root.querySelectorAll('[data-adf-ship]').forEach(function (s) { s.classList.add('is-later'); });
        }
      } catch (e) {}
    });
  }

  function money(cents) {
    var v = cents / 100;
    return (cents % 100 === 0 ? String(v) : v.toFixed(2).replace('.', ',')) + ' €';
  }

  /* ---------- Fiche produit ---------- */
  if (!customElements.get('adf-product')) {
    customElements.define('adf-product', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        var json = this.querySelector('[data-adf-variants]');
        this.variants = json ? JSON.parse(json.textContent) : [];
        this.freeFrom = parseInt(this.dataset.freeFrom, 10) || 0;
        this.form = this.querySelector('form[action*="/cart/add"]');
        this.idInput = this.form && this.form.querySelector('[name=id]');
        this.submit = this.querySelector('[data-adf-atc]');
        this.options = Array.prototype.slice.call(this.querySelectorAll('[data-adf-option]'));
        this.options.forEach((fs) => fs.addEventListener('change', () => this.onOptionChange()));
        this.syncSketch();
        this.initGallery();
        this.initZoom();
        this.initBar();
      }

      selected() {
        return this.options.map(function (fs) { var i = fs.querySelector('input:checked'); return i ? i.value : null; });
      }

      syncSketch() {
        var first = this.options[0];
        var sketch = this.querySelector('[data-adf-sketch]');
        if (!first || !sketch) return;
        var on = first.querySelector('input:checked');
        var idx = on ? on.getAttribute('data-index') : '0';
        sketch.querySelectorAll('[data-adf-size]').forEach(function (g) { g.classList.toggle('is-on', g.getAttribute('data-adf-size') === idx); });
      }

      onOptionChange() {
        var sel = this.selected();
        this.options.forEach(function (fs, i) {
          var out = fs.querySelector('[data-adf-option-value="' + i + '"]');
          if (out) out.textContent = sel[i] || '';
        });
        this.syncSketch();
        var v = this.variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { this.setUnavailable(); return; }
        this.variant = v;
        if (this.idInput) {
          this.idInput.value = v.id;
          this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        var p = money(v.price);
        this.querySelectorAll('[data-adf-price-amount], [data-adf-atc-price]').forEach(function (el) { el.textContent = p; });
        var cmp = this.querySelector('[data-adf-price-compare]');
        if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); if (!cmp.hidden) cmp.textContent = money(v.compare_at_price); }
        var meta = this.querySelector('[data-adf-bar-meta]');
        if (meta) meta.textContent = (this.variants.length > 1 ? v.title + ' · ' : '') + p;
        var free = this.freeFrom > 0 && v.price >= this.freeFrom;
        this.querySelectorAll('[data-adf-free]').forEach(function (el) { el.hidden = !free; });
        this.querySelectorAll('[data-adf-paid]').forEach(function (el) { el.hidden = free; });
        this.setAvailable(v.available);
        if (v.featured_media) this.goTo(String(v.featured_media.id));
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }

      setAvailable(ok) {
        if (!this.submit) return;
        this.submit.disabled = !ok;
        var label = this.submit.querySelector('[data-adf-atc-label]');
        if (label) {
          if (!label.dataset.adfDefault) label.dataset.adfDefault = label.textContent;
          label.textContent = ok ? label.dataset.adfDefault : 'Victime de son succès';
        }
        var bar = this.querySelector('[data-adf-bar-add]');
        if (bar) bar.disabled = !ok;
      }

      setUnavailable() { this.setAvailable(false); }

      /* Galerie : défilement horizontal + vignettes */
      initGallery() {
        this.slides = this.querySelector('[data-adf-slides]');
        this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-adf-thumb]'));
        if (!this.slides || !this.thumbs.length) return;
        this.thumbs.forEach((b) => b.addEventListener('click', () => this.goTo(b.getAttribute('data-adf-thumb'))));
        var t;
        this.slides.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            var i = Math.round(this.slides.scrollLeft / Math.max(1, this.slides.clientWidth));
            this.thumbs.forEach(function (b, k) { if (k === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
          }, 60);
        }, { passive: true });
      }

      goTo(mediaId) {
        if (!this.slides) return;
        var li = this.slides.querySelector('[data-media-id="' + mediaId + '"]');
        if (!li) return;
        this.slides.scrollTo({ left: li.offsetLeft - this.slides.offsetLeft, behavior: 'smooth' });
      }

      /* Zoom */
      initZoom() {
        var dlg = this.querySelector('[data-adf-zoom-dialog]');
        if (!dlg || typeof dlg.showModal !== 'function') return;
        var box = dlg.querySelector('[data-adf-zoom-box]');
        var img = document.createElement('img');
        img.decoding = 'async';
        box.appendChild(img);
        var open = () => {
          var i = this.slides ? Math.round(this.slides.scrollLeft / Math.max(1, this.slides.clientWidth)) : 0;
          var cur = this.querySelectorAll('.adf-pdp__slide img')[i];
          if (!cur) return;
          img.src = cur.getAttribute('data-zoom') || cur.currentSrc || cur.src;
          img.alt = cur.alt;
          if (cur.naturalWidth) { img.width = cur.naturalWidth; img.height = cur.naturalHeight; }
          dlg.showModal();
          document.documentElement.classList.add('adf-no-scroll');
        };
        var btn = this.querySelector('[data-adf-zoom]');
        if (btn) btn.addEventListener('click', open);
        this.querySelectorAll('.adf-pdp__slide img').forEach(function (im) { im.addEventListener('click', open); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg || e.target.closest('[data-adf-zoom-close]') || e.target === img) dlg.close(); });
        dlg.addEventListener('close', function () { document.documentElement.classList.remove('adf-no-scroll'); });
      }

      /* Barre d'achat collante (mobile) : apparaît quand le bouton principal est passé */
      initBar() {
        var bar = this.querySelector('[data-adf-bar]');
        if (!bar || !this.submit) return;
        var footer = document.querySelector('.adf-footer') || document.querySelector('footer');
        var shown = null, ticking = false;
        var check = () => {
          ticking = false;
          // visible dès que le bouton principal a glissé sous l'en-tête collant, cachée près du pied de page
          var past = this.submit.getBoundingClientRect().bottom < 96;
          var nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight - 40 : false;
          var show = past && !nearFooter;
          if (show === shown) return;
          shown = show;
          bar.classList.toggle('is-visible', show);
          bar.setAttribute('aria-hidden', show ? 'false' : 'true');
          bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
          document.documentElement.classList.toggle('adf-has-bar', show);
        };
        var onScroll = function () { if (!ticking) { ticking = true; setTimeout(check, 30); } };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        check();
        var add = bar.querySelector('[data-adf-bar-add]');
        if (add) add.addEventListener('click', () => {
          // Le mot sur la carte est obligatoire : s'il est vide, on y emmène directement le client
          var card = this.querySelector('.adf-pdp__apps textarea');
          if (card && !card.value.trim()) {
            card.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(function () { card.focus({ preventScroll: true }); }, 450);
            return;
          }
          this.submit.click();
        });
      }
    });
  }

  /* ---------- Collection : tri + texte repliable ---------- */
  function tools(scope) {
    (scope || document).querySelectorAll('[data-adf-sort]').forEach(function (sel) {
      if (sel._adf) return; sel._adf = true;
      sel.addEventListener('change', function () { sel.form.submit(); });
    });
    (scope || document).querySelectorAll('[data-adf-clamp]').forEach(function (box) {
      if (box._adf) return; box._adf = true;
      var btn = box.querySelector('[data-adf-clamp-btn]');
      var p = box.querySelector('p');
      if (!btn || !p) return;
      if (p.scrollHeight > p.clientHeight + 2) btn.hidden = false;
      btn.addEventListener('click', function () {
        var open = box.classList.toggle('is-open');
        btn.textContent = open ? 'Réduire' : 'Lire la suite';
      });
    });
  }

  /* ---------- « Vous aimerez aussi » ---------- */
  function recos(scope) {
    (scope || document).querySelectorAll('.adf-recos--pending[data-adf-recos]').forEach(function (sec) {
      if (sec._adf) return; sec._adf = true;
      var load = function () {
        fetch(sec.getAttribute('data-adf-recos'))
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-adf-recos]');
            if (!fresh || !fresh.querySelector('.adf-prod__card')) return;
            sec.innerHTML = fresh.innerHTML;
            sec.classList.remove('adf-recos--pending');
            ship(sec.parentNode);
          })
          .catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '0px 0px 600px 0px' });
        io.observe(sec);
      } else load();
    });
  }

  function init(scope) { ship(scope); tools(scope); recos(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.adfShip = ship;
})();
